import React from 'react';
import { Label } from '@nooz-optics/nooz-components-lib';
import { useMediaQuery } from '../../../../../utils/hooks/useMediaQuery';
import { Video } from '../../../../UI/Media';
import { Image } from '../../../../UI/Media/Image';
import { BannerButtons } from '../../../Banners/BannerButtons/bannerButtons';

export const SplitImageLabelPanel = ({
  image,
  desktopImage,
  video,
  label,
  body,
  buttons,
  color,
  backgroundImage,
  isFullScreenWidth,
  imageFirst = { value: false },
  index,
  hasFullScreenElement,
  hasOnePanelOnly = true,
}) => {
  const isWindowSmall = useMediaQuery('lg');
  const isFirstPanel = index === 0;
  const isSecondPanelAndHasNoFullScreenElement =
    index === 1 && !hasFullScreenElement;

  const borderY = isFullScreenWidth?.value ? 'border-t border-b' : '';
  const wrapperWidth = isFullScreenWidth?.value ? 'w-screen' : 'w-full';
  const bgColor = color ? `bg-${color?.classname}` : 'bg-white';
  const textColor = backgroundImage ? 'text-white' : 'gray-800';

  return (
    <div
      id='split-panel'
      className={`relative flex flex-col lg:flex-row justify-center min-h ${borderY} ${bgColor} ${wrapperWidth}`}
      style={{
        backgroundImage:
          backgroundImage && `url(${backgroundImage.media?.file?.url})`,
        backgroundSize: backgroundImage && 'cover',
      }}>
      <div className='lg:absolute overflow-hidden  lg:inset-0'>
        <div
          className={`lg:absolute lg:inset-y-0 lg:${
            imageFirst.value ? 'left-0' : 'right-0'
          } lg:w-1/2`}>
          {(image || desktopImage) && (
            <>
              <span className='block md:hidden h-full w-full'>
                <Image
                  {...image}
                  objectFit='cover'
                  height='100%'
                  width='100%'
                />
              </span>
              <span className='hidden md:block h-full w-full'>
                <Image
                  objectFit='cover'
                  {...(desktopImage || image)}
                  height='100%'
                  width='100%'
                />
              </span>
            </>
          )}
          {video && (
            <Video
              {...video}
              height={isWindowSmall ? '300px' : '100%'}
              width='100%'
            />
          )}
        </div>
      </div>
      <div
        className={`relative main-wrapper my-16 w-full py-16 sm:m-0 sm:py-24 lg:py-32 lg:grid lg:grid-cols-2 ${textColor}`}>
        {/* Left empty Div for image spacer on the left */}
        {imageFirst.value && <div />}
        <div
          className={`h-full ${
            imageFirst.value ? 'pl-14' : 'pr-14'
          } flex flex-col items-start"`}>
          <div className='mb-6'>
            <Label
              {...label}
              weight='bold'
              size='3xl'
            />
          </div>
          <div className='mb-6'>
            <Label
              {...body}
              size='lg'
            />
          </div>
          <BannerButtons
            buttons={buttons}
            size='lg'
          />
        </div>
        {/* Right empty Div for image spacer on the right */}
        {!imageFirst.value && <div />}
      </div>
    </div>
  );
};
